//eslint-disable-next-line no-unused-vars
export const permissionCheck = (navigation, permission) => {
  return true; //todo: implement this and get our permission keys all dialed in.
};

export const realPermissionCheck = (permissions = [], permission, targetId) => {
  const nameMatches = permissions.filter((x) => x.permission === permission);
  if (targetId) {
    return nameMatches.length > 0;
  }
  return !!nameMatches.find((x) => x.targetId.toString() === targetId.toString());
};
